import React from 'react';
import Highcharts from 'highcharts';
import { options } from './options';

export default class Chart extends React.Component {

  generateChart = (isFirstRender) => {
    const { chartType, chartId, data, isEmpty, tooltipFormatter, customChartOptions, disableAnimation } = this.props;
    const copyChartType = Object.assign({}, chartType);
    Highcharts.setOptions(options);
    if (!copyChartType.chart) {
      copyChartType.chart = {};
    }
    copyChartType.chart.animation = !disableAnimation;
    if (!copyChartType.plotOptions) {
      copyChartType.plotOptions = {};
    }
    if (!copyChartType.plotOptions.series) {
      copyChartType.plotOptions.series = {};
    }
    copyChartType.plotOptions.series.animation = !disableAnimation;

    copyChartType.series[0] = {
      colorByPoint: true,
      // If the chart is empty, we draw a full circle
      data: isEmpty ? [['', 100]] : data
    };

    // If the chart is empty, we color the circle grey
    if (isEmpty) {
      copyChartType.colors = ['#dedede'];
    }

    if (tooltipFormatter) {
      // If the chart is empty, we disable tooltips
      if (isEmpty) {
        copyChartType.tooltip = { enabled: false };
      } else {
        copyChartType.tooltip = {
          useHTML: true,
          formatter: function () {
            return tooltipFormatter(this);
          }
        };
      }
    }

    // TODO(peter): This is here for now so that we can override the charts on the Creator Report
    //              page to have a legend, but not on the Org Dashboard
    for (let customOption in customChartOptions) {
      if (customChartOptions.hasOwnProperty(customOption)) {
        copyChartType[customOption] = customChartOptions[customOption];
      }
    }

    // When the chart renders, the div is sized based on the chart itself, reflow if its the first render
    const chart = Highcharts.chart(chartId, copyChartType);
    if (isFirstRender) {
      chart.reflow();
    }
  };

  componentDidUpdate () {
    const { forceReflowBecauseOfBug } = this.props;
    this.generateChart(forceReflowBecauseOfBug);
  }

  componentDidMount () {
    // Force out the initial chart render
    // Since render() does so little, componentDidUpdate doesn't actually get called the first time.
    this.generateChart(true);
  }

  render () {
    const { chartId, data, customChartContainerClass, customChartClass } = this.props;
    return (
      <div className={ `${!!customChartContainerClass && customChartContainerClass}` }>
        <div id={ chartId } className={ `${!!customChartClass && customChartClass}` } />
        { /* We need to use data prop somewhere in render or React won't watch it for changes. */ }
        <div key={ data ? data.length : 0 } />
      </div>
    );
  }
}
